/** biome-ignore-all lint/complexity/useSimpleNumberKeys: this rule would messup our color codes like 500_8 => 5008 */
import { alpha, type ThemeOptions } from '@mui/material';
import type { DeepPartial } from 'types/utils';

// Base color: #596F4F, step up 8%, step down 11%
// https://www.tailwindshades.com/#color=101.25000000000001%2C16.842105263157894%2C37.254901960784316&step-up=8&step-down=11&hue-shift=0&name=cactus&base-stop=5&v=1&overrides=e30%3D
const primary = {
  lighter: '#809C74', // 300
  light: '#6C8760', // 400
  main: '#596F4F', // 500
  dark: '#3F4E38', // 600
  darker: '#242D20', // 700
};

// Base color: #A3A8A6, step up 8%, step down 14%
// https://www.tailwindshades.com/#color=155%2C3%2C65&step-up=8&step-down=11&hue-shift=0&name=edward&base-stop=5&v=1&overrides=e30%3D
const grey = {
  100: '#F7F8F7',
  200: '#E2E4E3',
  300: '#CDD0CF',
  400: '#B8BCBA',
  500: '#A3A8A6',
  600: '#868D8A',
  700: '#6A716E',
  800: '#4F5452',
  900: '#343736',
  500_8: alpha('#A3A8A6', 0.08),
  500_12: alpha('#A3A8A6', 0.12),
  500_16: alpha('#A3A8A6', 0.16),
  500_24: alpha('#A3A8A6', 0.24),
  500_32: alpha('#A3A8A6', 0.32),
  500_48: alpha('#A3A8A6', 0.48),
  500_56: alpha('#A3A8A6', 0.56),
  500_80: alpha('#A3A8A6', 0.8),
};

export const themeOptions: DeepPartial<ThemeOptions> = {
  palette: {
    primary,
    grey,
    background: {
      default: '#EEEFEF',
    },
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    action: {
      hover: alpha('#DAE8B0', 0.32), // Dropdown menu hover background color
    },
    navBar: {
      menuActiveBg: '#DAE8B0',
      menuActiveText: '#04643C',
      menuDefaultText: primary.main,
      menuHoverBg: alpha('#DAE8B0', 0.48),
      menuHoverText: primary.main,
      menuSecondaryText: grey[600],
    },
  },
};
